import Code from './assets/nodejs.png'
import ReactLogo from './assets/ReactLogo.png'
import Postgres from './assets/postgresql.png'
import Github from './assets/github-logo.png'
import Docker from './assets/dockerImg.png'
import AWS from './assets/AWSLogo.png'
import AWS_S3 from './assets/AWS_S3.png'
import jQueryLogo from './assets/jQueryLogo.png'
import CloudDatabase from './assets/CloudDatabase.png'


const data = [
    {
        "id": 1,
        "name": "NodeJs",
        "alt": "NodeJs",
        "content": "Node.js is an open-source and cross-platform JavaScript runtime environment. It is a popular tool for almost any kind of project!",
        "img": Code
    },
    {
        "id": 2,
        "name": "ReactJS",
        "alt": "ReactJS",
        "content": "React is a framework that employs Webpack to automatically compile React, JSX, and ES6 code while handling CSS file prefixes. React is a JavaScript-based UI development library.",
        "img": ReactLogo
    },
    {
        "id": 3,
        "name": "Postgres",
        "alt": "Postgres",
        "content": "PostgreSQL is a powerful, open source object-relational database system. It a strong reputation for reliability, feature robustness, and performance.",
        "img": Postgres
    },
    {
        "id": 4,
        "name": "GitHub",
        "alt": "GitHub",
        "content": "Projects on GitHub can be accessed and managed using the standard Git command-line interface.",
        "img": Github
    },
    {
        "id": 5,
        "name": "Docker",
        "alt": "Docker",
        "content": "Spin up new environments quickly, Integrate with your existing tools and Containerize applications for consistency",
        "img": Docker
    },
    {
        "id": 6,
        "name": "AWS",
        "alt": "AWS",
        "content": "Spin up new environments quickly, Integrate with your existing tools and Containerize applications for consistency",
        "img": AWS
    },
    {
        "id": 7,
        "name": "AWS_S3",
        "alt": "AWS_S3",
        "content": "Spin up new environments quickly, Integrate with your existing tools and Containerize applications for consistency",
        "img": AWS_S3
    },
    {
        "id": 8,
        "name": "jQuery",
        "alt": "jQuery",
        "content": "Spin up new environments quickly, Integrate with your existing tools and Containerize applications for consistency",
        "img": jQueryLogo
    },
    {
        "id": 9,
        "name": "CloudDatabase",
        "alt": "CloudDatabase",
        "content": "Spin up new environments quickly, Integrate with your existing tools and Containerize applications for consistency",
        "img": CloudDatabase
    },
]

export default data;